import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from "@ngneat/transloco";
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { SvcDialogConfigComponent } from './components/svc-dialog-config/svc-dialog-config.component';
import { SvcDialogPrimaryComponent } from './components/svc-dialog-primary/svc-dialog-primary.component';
import { SvcConfirmDialogComponent } from './components/svc-confirm-dialog/svc-confirm-dialog.component';
import { SvcDialogActions, SvcDialogComponent, SvcDialogContent, SvcDialogTitle } from './components/svc-dialog/svc-dialog.component';
import { SvcDialogService } from "./svc-dialog.service";
import { SvcWarningDialogComponent } from './components/svc-warning-dialog/svc-warning-dialog.component';
import { SvcAlertDialogComponent } from './components/svc-alert-dialog/svc-alert-dialog.component';
import { SvcButtonIconModule } from '../svc-btn-icon';
import { SvcButtonModule } from '../svc-btn';
import { SvcImagesViewerModalModule } from '../modals/svc-modal-image-viewer/svc-modal-image-viewer.module';
import { SvcFilledBtnModule, SvcOutlinedBtnModule } from '../svc-btn';
import { SvcCopilotConfirmDialogComponent } from './components/svc-copilot-confirm-dialog/svc-copilot-confirm-dialog.component';
import { ZardTooltipDirective } from '@solvace/zard/shared/components/tooltip/tooltip';
import { SvzTruncatedTooltipDirective } from '@solvace/zard/svz-truncated-tooltip/svz-truncated-tooltip.directive';

@NgModule({
  declarations: [
    SvcDialogConfigComponent,
    SvcDialogPrimaryComponent,
    SvcDialogComponent,
    SvcDialogActions,
    SvcDialogTitle,
    SvcDialogContent,
    SvcConfirmDialogComponent,
    SvcWarningDialogComponent,
    SvcAlertDialogComponent,
    SvcCopilotConfirmDialogComponent,
    SvcWarningDialogComponent,
    SvcAlertDialogComponent
  ],
  imports: [
    LibSharedCommonModule,
    SvcImagesViewerModalModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    TranslocoModule,
    MatMenuModule,
    SvcButtonIconModule,
    SvcButtonModule,
    SvcOutlinedBtnModule,
    ZardTooltipDirective,
    SvzTruncatedTooltipDirective,
    SvcFilledBtnModule,
  ],
  exports: [
    SvcDialogConfigComponent,
    SvcDialogPrimaryComponent,
    SvcDialogComponent,
    SvcDialogActions,
    SvcDialogTitle,
    SvcDialogContent,
  ],
  providers: [
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    {
      provide: MatDialogRef,
      useValue: {}
    },
    SvcDialogService
  ]
})
export class SvcDialogsModule { }
